import React from "react";
import styled from "styled-components";

const Container = styled.div`
  z-index: 1;
  padding-left: 24px;
  max-width: 70%;

  a {
    color: #858bff;
  }
`;

export const TermsAndConditionsIt = () => {
  return (
    <Container>
      <h1>Aste Online del Programma Alimentare Mondiale</h1>
      <p>
        Questi termini di utilizzo ("Termini") regolano l'uso e la
        partecipazione allo strumento di aste online del Programma Alimentare
        Mondiale ("Piattaforma") tra l'utente della Piattaforma ("Utente") e il
        Programma Alimentare Mondiale ("PAM"). Accedendo o utilizzando la
        Piattaforma e i suoi servizi, l'Utente accetta di rispettare e di essere
        vincolato da questi Termini.
      </p>

      <h2>1. Definizioni</h2>
      <p>
        “Asta”: processo mediante il quale gli Utenti effettuano offerte su
        articoli elencati sulla Piattaforma.
      </p>
      <p>
        “Offerente”: Utente che effettua offerte su Lotti elencati sulla
        Piattaforma, che ha più di 18 anni ed è legalmente in grado di stipulare
        contratti legalmente vincolanti.
      </p>
      <p>
        “Incremento minimo” o “Rilancio”: aumento minimo predefinito
        dell'importo dell'offerta che l'Offerente può effettuare per un
        determinato Lotto.
      </p>
      <p>
        “Lotto”: articolo singolo o gruppo di articoli offerti all'asta dal PAM
        sulla Piattaforma. Comprende tutte le informazioni, incluse, ma non
        solo, descrizioni testuali, immagini, contenuti multimediali, importi di
        offerta iniziali, prezzo minimo di aggiudicazione, durata e qualsiasi
        termine o condizione aggiuntiva specificata dal PAM e presentata sulla
        Piattaforma in relazione all’Asta.
      </p>
      <p>
        “Proposta di acquisto” o “Offerta”: proposta fatta da un Offerente sulla
        Piattaforma per acquistare un Lotto.
      </p>
      <p>“Piattaforma”: applicazione mobile per le aste online del PAM.</p>
      <p>
        “Prezzo minimo di aggiudicazione”: importo minimo predefinito e non
        divulgato per cui PAM può aggiudicare un Lotto.
      </p>
      <p>
        “Requisiti” si riferisce a qualsiasi requisito legale o normativo, con o
        senza implicazioni finanziarie, inclusi, ma non limitati a, licenze,
        permessi o registrazioni cui alcuni articoli messi all’asta sulla
        Piattaforma possono essere soggetti.
      </p>
      <p>“Utente”: individuo o entità che utilizza la Piattaforma.</p>
      <p>
        “Account Utente”: account utilizzato dall’Utente per accedere alla
        Piattaforma.
      </p>
      <p>
        “Offerente vincente”: Offerente la cui offerta è stata accettata dal
        PAM.
      </p>
      <p>
        “Marchi PAM”: nome, emblema e abbreviazione del Programma Alimentare
        Mondiale.
      </p>

      <h2>2. Utilizzo della Piattaforma</h2>
      <p>
        2.1. Regole interne e Account Utente: L'Utente potrebbe dover
        registrarsi e/o creare un Account Utente per accedere o utilizzare
        alcune sezioni della Piattaforma. L'Utente non può mai utilizzare
        l'account di un altro utente senza autorizzazione. Registrandosi o
        creando un Account Utente, l'Utente dichiara e garantisce che (i) è
        maggiorenne o possiede il consenso legale di un genitore o tutore ed è
        pienamente competente e in grado di rispettare e conformarsi a questi
        Termini; e (ii) se l’Utente rappresenta un'entità legale, esso ha
        l'autorità di vincolare tale entità ai presenti Termini. L'Utente è
        responsabile della riservatezza della password e delle altre
        informazioni di accesso e deve informare il PAM se ritiene che tali dati
        siano stati compromessi e/o utilizzati impropriamente da terzi,
        adottando le misure necessarie e/o richieste per prevenire tale uso
        improprio. L'Utente è responsabile di tutte le attività svolte tramite
        il proprio Account Utente.
      </p>
      <p>
        2.2. I contenuti di terze parti visualizzati sul Sito possono essere
        utilizzati solo previo consenso del proprietario o come consentito dalla
        legge applicabile, a seconda dei casi. Nulla nei presenti Termini di
        Utilizzo sarà considerato come conferimento di diritti o benefici a
        terzi su tali contenuti.
      </p>
      <p>
        2.2. Sospensione e cessazione: Il PAM si riserva il diritto di
        sospendere o terminare l'accesso dell'Utente a propria discrezione,
        incluso per violazione dei presenti Termini, in particolare se l'Utente
        effettua offerte senza l'intenzione di acquistare, non ritira i Lotti
        entro il tempo stabilito o per qualsiasi altro motivo. I diritti e gli
        obblighi dell'Utente derivanti da un'Offerta presentata in relazione a
        un Lotto rimarranno invariati in caso di modifica, sospensione o
        cessazione dell'Account Utente.
      </p>
      <p>2.3. L'utilizzo della Piattaforma è gratuito.</p>

      <p>
        2.4. Condotta dell'Utente: L'Utente è l'unico responsabile della propria
        condotta nella Piattaforma.
      </p>

      <p>
        L'Utente accetta di utilizzare la piattaforma esclusivamente per inviare
        e ricevere informazioni, contenuti e materiali appropriati e pertinenti
        all'utilizzo della Piattaforma. A titolo esemplificativo e non
        limitativo, l'Utente accetta che, durante l'utilizzo della Piattaforma,
        non:
      </p>
      <ul>
        <p>
          a. Diffami, abusi, molesti, perseguiti, minacci o in altro modo violi
          i diritti legali (come il diritto alla privacy e alla pubblicità) di
          altri;
        </p>
        <p>
          b. Pubblichi, posti, distribuisca o diffonda materiale o informazioni
          diffamatorie, lesive, oscene, indecenti o illegali;
        </p>
        <p>
          c. Carichi o alleghi file contenenti software o altro materiale
          protetto dalle leggi sulla proprietà intellettuale (o dai diritti alla
          privacy e alla pubblicità) a meno che l’ Utente non possieda o
          controlli i diritti o abbia ottenuto tutti i consensi richiesti dalla
          legge;
        </p>
        <p>
          d. Carichi o alleghi file contenenti virus, file corrotti o altri
          software o programmi simili che possano danneggiare il funzionamento
          dei sistemi del PAM;
        </p>
        <p>e. Eluda, disabiliti o interferisca con la Piattaforma;</p>
        <p>
          f. Rimuova attribuzioni d'autore, avvisi legali o designazioni o
          etichette proprietarie presenti nei file o nei contenuti caricati;
        </p>
        <p>
          g. Falsifichi l'origine o la fonte di software o altro materiale
          contenuto in un file o contenuto caricato;
        </p>
        <p>
          h. Intraprenda qualsiasi azione che possa compromettere o indebolire i
          diritti del PAM ai sensi del presente documento, o la reputazione
          associata al suo nome, al nome delle Nazioni Unite o di qualsiasi
          organizzazione del sistema delle Nazioni Unite.
        </p>
      </ul>
      <p>
        Il PAM si riserva il diritto, a sua esclusiva discrezione, di negare
        l'accesso alla Piattaforma o a qualsiasi sua parte a qualsiasi utente
        senza preavviso, di sospendere, revocare o interrompere la fornitura
        degli account utenti se l'Utente non rispetta i presenti Termini di
        Utilizzo e di rimuovere, per qualsiasi motivo e senza preavviso,
        qualsiasi informazione o materiale fornito dall'Utente.
      </p>
      <h2>3. Asta e Partecipazione all’offerta</h2>
      <p>
        3.1. Invito all’offerta da parte del PAM: La pubblicazione o messa a
        disposizione dei Lotti sulla Piattaforma da parte del PAM non
        costituisce un’offerta vincolante o esecutiva né un contratto tra il PAM
        e l’Offerente. Si tratta di una richiesta non vincolante di proposta,
        senza alcun obbligo da parte del PAM di accettare alcuna Offerta
        presentata in seguito all’invito all’ offerta, anche qualora tale
        Offerta soddisfi pienamente tutti i requisiti dell’invito stesso. In
        merito all’aggiudicazione del Lotto, tutti i Lotti messi all’asta sono
        soggetti a un Prezzo minimo di aggiudicazione stabilito dal PAM. Il PAM
        non è obbligato a divulgare tale Prezzo minimo e si riserva il diritto
        di rifiutare qualsiasi Offerta e di non procedere all’aggiudicazione del
        Lotto qualora l’Offerta non raggiunga il Prezzo minimo di
        aggiudicazione.
      </p>
      <p>
        3.2. Cancellazione delle inserzioni: Il PAM si riserva il diritto di
        cancellare in qualsiasi momento l’inserzione e di revocare
        l’aggiudicazione, in tutto o in parte, per qualsiasi motivo, incluso il
        caso in cui l’Offerente vincente non sia in grado di effettuare il
        pagamento completo entro 5 giorni lavorativi dalla conclusione
        dell’Asta.
      </p>
      <p>
        3.3. Offerta dell’Offerente: L’Offerente accetta e riconosce che
        un’Offerta costituisce un impegno legalmente vincolante da parte sua ad
        acquistare il Lotto, a condizione che la sua Offerta venga identificata
        dal PAM come Offerta vincente, secondo le regole e le procedure
        dell’asta condotta sulla Piattaforma. L’Offerta presentata
        dall’Offerente rappresenta l’importo monetario specifico che l’Offerente
        si impegna a pagare per l’articolo al PAM. L’Offerente è consapevole e
        accetta che eventuali tasse, imposte o altri oneri aggiuntivi imposti
        dal governo dell’Offerente vincente saranno a carico esclusivo
        dell’Offerente stesso e costituiranno una sua responsabilità esclusiva.
      </p>
      <p>
        3.4. Le offerte si svolgono elettronicamente tramite la Piattaforma
        durante il periodo indicato per ciascun Lotto. Ogni Lotto specifica
        un’ora di apertura e di chiusura. Le offerte devono essere presentate
        prima dell’orario di chiusura indicato per il Lotto sulla Piattaforma.
        Tutti gli orari visualizzati sulla Piattaforma sono espressi nell’ora
        locale dell’Ufficio Paese che conduce l’Asta, salvo diversa indicazione.
      </p>
      <p>
        3.5.{" "}
        <strong>Estensione automatica del tempo di chiusura del Lotto: </strong>
        Per favorire una concorrenza leale e garantire pari opportunità di
        offerta, il tempo di chiusura di ciascun Lotto può essere
        automaticamente esteso se una o più offerte valide vengono presentate
        negli ultimi cinque (5) minuti precedenti l’orario di chiusura previsto.
        <br />
        Ogni nuova offerta presentata in questo periodo estenderà il tempo di
        chiusura del Lotto di ulteriori cinque (5) minuti dal momento in cui è
        stata ricevuta l’ultima offerta.
        <br />
        Il Lotto si chiuderà solo quando non verranno più ricevute offerte negli
        ultimi cinque (5) minuti del periodo esteso.
        <br />
        Questo meccanismo si applica individualmente a ciascun Lotto e
        garantisce a tutti gli Offerenti interessati una possibilità equa di
        rispondere alle offerte concorrenti.
        <br />
        Il PAM non sarà ritenuto responsabile di eventuali ritardi o
        malfunzionamenti nella trasmissione dei dati, nella connessione Internet
        o nelle prestazioni del dispositivo che possano impedire a un Offerente
        di partecipare durante il periodo di estensione.
      </p>
      <p>
        3.6. <strong>Offerta vincente e aggiudicazione:</strong> Alla scadenza
        del tempo di chiusura – inclusa qualsiasi estensione automatica
        applicata ai sensi del paragrafo 3.2 – l’offerta valida più alta
        ricevuta sarà considerata l’Offerta Vincente.
        <br />
        L’Offerente che ha presentato l’Offerta Vincente (“Offerente Vincente”)
        sarà informato tramite la Piattaforma o via e-mail.
        <br />
        Il PAM si riserva il diritto di verificare la validità delle offerte e
        di annullare o riassegnare qualsiasi Lotto in caso di errore, sospetta
        frode o mancato rispetto dei presenti Termini.
      </p>
      <p>
        3.7. Presentando un’offerta, l’Offerente riconosce e accetta che ogni
        offerta è vincolante e irrevocabile fino alla chiusura dell’Asta per
        quel Lotto ai sensi dei paragrafi 3.4 e 3.5.
        <br />
        L’Offerente Vincente è tenuto a completare il pagamento e le procedure
        di ritiro nei tempi e alle condizioni specificate dal PAM.
        <br />
        Il mancato rispetto può comportare la perdita di qualsiasi deposito o
        garanzia e l’esclusione da aste future.
      </p>

      <h2>4. Transazioni</h2>
      <p>
        4.1. Istruzioni di pagamento: A seguito dell’aggiudicazione, l’Offerente
        vincente sarà informato tramite un’email inviata all’indirizzo di posta
        elettronica dell’Utente. Tale email conterrà le istruzioni di pagamento
        pertinenti. Qualsiasi pagamento al PAM dovrà essere effettuato entro 5
        giorni dalla data di aggiudicazione tramite bonifico bancario. Eventuali
        commissioni applicate dalla banca in relazione a tale trasferimento
        saranno a carico dell’Offerente.
      </p>
      <p>
        4.2. Consegna: Una volta ricevuto il pagamento, il PAM fornirà
        all’Offerente vincente le istruzioni per il ritiro. Il PAM renderà
        quindi l’articolo disponibile e accessibile per il ritiro presso la sede
        del PAM situata in Via Cesare Giulio Viola 68, Parco dei Medici, 00148 –
        Roma – Italia, previa presentazione di un documento di identità valido.
      </p>
      <p>
        4.3. Resi e Rimborsi: Il PAM non accetta la restituzione di alcun
        articolo e non è responsabile per alcun rimborso all’Offerente vincente.
      </p>
      <p>
        4.4. Responsabilità di verifica dell’Offerente: L’Offerente vincente
        riconosce che alcuni articoli messi all’asta sulla Piattaforma possono
        essere soggetti a requisiti legali o normativi, inclusi, ma non limitati
        a, licenze, permessi o registrazioni (“Requisiti”) che devono essere
        ottenuti per la legittima detenzione, uso o proprietà dell’articolo. È
        responsabilità esclusiva dell’Offerente vincente informarsi e
        identificare eventuali Requisiti applicabili associati a un articolo
        prima di effettuare un’offerta. Partecipando all’asta, l’Offerente
        vincente conferma di aver svolto la necessaria verifica preventiva per
        determinare se tali Requisiti si applichino all’articolo per cui sta
        facendo un’offerta.
      </p>
      <h2>5. Responsabilità</h2>
      <p>
        5.1. Garanzia limitata e dichiarazioni di non responsabilità: Il PAM
        declina espressamente ogni garanzia e informa che gli articoli messi
        all’asta sono forniti “così come sono” e “come disponibili”, senza
        alcuna garanzia espressa o implicita di alcun tipo. Questo include, ma
        non è limitato a, garanzie di commerciabilità, idoneità a uno scopo
        particolare o non violazione di diritti di terzi. Il PAM non potrà
        essere ritenuto responsabile per lo stato, la qualità, l’autenticità, la
        legalità o l’idoneità degli articoli elencati per l’asta. Il PAM non
        sarà responsabile per danni diretti, indiretti, accidentali,
        consequenziali, speciali o punitivi, né per perdite di profitti o
        ricavi, siano essi subiti direttamente o indirettamente, né per perdite
        di avviamento o altre perdite immateriali derivanti dall’uso degli
        articoli acquisiti dall’Utente o da qualsiasi transazione effettuata
        sulla Piattaforma. Al momento della consegna degli articoli all’Utente,
        quest’ultimo assume tutte le responsabilità, i rischi e gli obblighi
        relativi agli articoli.
      </p>
      <p>
        5.2. Esclusione di responsabilità per la Piattaforma: L’uso della
        Piattaforma e di qualsiasi sua funzionalità è a esclusivo rischio
        dell’Utente. La Piattaforma, i suoi contenuti e le sue funzionalità sono
        forniti “così come sono” e “come disponibili”, senza alcuna garanzia,
        espressa o implicita, inclusa, a titolo esemplificativo ma non
        esaustivo, la garanzia di commerciabilità, idoneità a uno scopo
        particolare e non violazione. Il PAM non fornisce alcuna garanzia o
        dichiarazione in merito all’accuratezza o alla completezza delle
        informazioni presentate sulla Piattaforma. Il PAM aggiorna, modifica,
        migliora o integra periodicamente la Piattaforma, i materiali e le
        funzionalità senza preavviso. L’Utente riconosce e accetta espressamente
        che il PAM non è responsabile per la condotta di alcun Utente e declina
        ogni responsabilità in relazione all’uso della Piattaforma.
      </p>
      <p>
        5.3. Come condizione per l’utilizzo della Piattaforma e di qualsiasi suo
        contenuto o funzionalità, l’Utente accetta di indennizzare il PAM, il
        suo personale, i suoi funzionari e dipendenti da e contro qualsiasi
        azione, reclamo, perdita, danno, responsabilità e spesa (incluse le
        ragionevoli spese legali) derivanti dall’uso del Sito da parte
        dell’Utente, inclusi, a titolo esemplificativo ma non esaustivo,
        eventuali reclami basati su fatti che, se veri, costituirebbero una
        violazione da parte dell’Utente dei presenti Termini di Utilizzo.
      </p>
      <h2>6. Protezione dei Dati</h2>
      <p>
        6.1. L’utilizzo della Piattaforma non richiede all’Utente di fornire
        dati personali al PAM. Tuttavia, gli Utenti devono registrarsi sulla
        Piattaforma per poter presentare una Proposta o effettuare un’Offerta
        per articoli o Lotti del PAM. Il PAM, in qualità di titolare del
        trattamento, tratterà (i) i dati identificativi e di contatto
        dell’Utente per gestire la sua registrazione sulla Piattaforma; (ii) una
        volta effettuata una Proposta o un’Offerta, per informarlo sullo stato
        dell’Offerta; e (iii) le informazioni collegate alla Proposta o Offerta
        per eseguire il processo d’asta e decidere l’assegnazione. Tutte queste
        attività di trattamento sono necessarie per la partecipazione al
        processo d’asta del PAM tramite la Piattaforma e saranno svolte in
        conformità con le regole e i regolamenti del PAM.
      </p>
      <p>
        6.2. I dati personali dell’Utente saranno accessibili solo da personale
        autorizzato del PAM, esclusivamente su base di necessità. Non sono
        previsti trasferimenti di dati personali a terze parti.
      </p>
      <p>
        6.3. Il PAM implementa misure adeguate di riservatezza e sicurezza per
        proteggere i dati personali. I dati personali saranno conservati per il
        tempo necessario e, in ogni caso, secondo le regole e i regolamenti del
        PAM. I diritti in materia di protezione dei dati possono essere
        esercitati in qualsiasi momento contattando:
        support.auctiondigitaloffice@wfp.org
      </p>
      <h2>7. Risoluzione delle Controversie</h2>
      <p>
        7.1. I presenti Termini di Utilizzo e qualsiasi controversia da essi
        derivante saranno regolati esclusivamente dai principi internazionali di
        diritto internazionale, con esclusione di qualsiasi sistema giuridico
        nazionale.
      </p>
      <p>
        7.2. Qualsiasi controversia, conflitto o reclamo derivante da o relativo
        ai presenti Termini di Utilizzo, o alla loro violazione, cessazione o
        invalidità, oppure all’uso del Sito, dei materiali e delle funzionalità
        da parte dell’Utente, o a qualsiasi contenuto disponibile sul Sito e ai
        relativi termini di utilizzo, sarà risolta mediante arbitrato in
        conformità con le Regole Arbitrali UNCITRAL allora in vigore. Il
        tribunale arbitrale, composto da un (1) arbitro, avrà il potere di
        ordinare: (i) la restituzione o distruzione di beni o proprietà,
        tangibili o intangibili, o di qualsiasi informazione riservata fornita
        ai sensi del presente documento; (ii) la cessazione del presente
        accordo; oppure (iii) l’adozione di qualsiasi altra misura protettiva
        relativa a beni, servizi o proprietà, tangibili o intangibili, o a
        informazioni riservate fornite ai sensi del presente documento, come
        appropriato, tutto in conformità con l’autorità conferita al tribunale
        arbitrale ai sensi dell’Articolo 26 (“Misure Provvisorie”) e
        dell’Articolo 34 (“Forma ed Effetto del Lodo”) delle Regole Arbitrali
        UNCITRAL. Il tribunale arbitrale non avrà l’autorità di assegnare danni
        punitivi. Il PAM e l’Utente saranno vincolati da qualsiasi lodo
        arbitrale emesso come risultato di tale arbitrato, che costituirà la
        decisione definitiva su qualsiasi controversia. La lingua di tali
        procedimenti sarà l’inglese e la sede sarà Roma.
      </p>
      <p>
        7.3. Qualora esistano più versioni linguistiche dei presenti Termini e
        vi siano discrepanze tra di esse, prevarrà sempre la versione in lingua
        inglese.
      </p>
      <h2>8. Salvaguardia delle Immunità</h2>
      <p>
        Nulla nei presenti Termini di Utilizzo potrà essere interpretato come
        una rinuncia, espressa o implicita, da parte del PAM, delle Nazioni
        Unite o dell’Organizzazione delle Nazioni Unite per l’Alimentazione e
        l’Agricoltura (FAO), a qualsiasi privilegio o immunità di cui godono in
        virtù della Convenzione sui Privilegi e le Immunità delle Nazioni Unite
        del 1946, della Convenzione sui Privilegi e le Immunità delle Agenzie
        Specializzate del 1947, del diritto internazionale consuetudinario, di
        altri accordi internazionali o nazionali pertinenti, e ai sensi del
        diritto interno.a
      </p>
      <h2>9. Varie</h2>
      <p>
        9.1. Modifiche ai Termini: Il PAM si riserva il diritto esclusivo, a sua
        sola discrezione, di (i) modificare, limitare o interrompere l’accesso
        alla Piattaforma in qualsiasi modo; e (ii) modificare unilateralmente i
        presenti Termini di Utilizzo. Il PAM non ha alcun obbligo di tenere
        conto delle esigenze di alcun Utente in relazione a tali modifiche.
      </p>
      <p>
        9.2. Uso del nome o dei Segni distintivi: I Segni distintivi del PAM
        sono di proprietà esclusiva del PAM e sono protetti dal diritto
        internazionale. L’uso non autorizzato dei Segni distintivi del PAM è
        vietato. Tali Segni non possono essere riprodotti o utilizzati in alcun
        modo senza il previo consenso scritto del PAM. La menzione o l’omissione
        di aziende specifiche, dei loro prodotti o marchi sulla Piattaforma non
        implica alcuna approvazione o giudizio da parte del PAM.
      </p>
      <p>
        9.3. Clausola di separabilità: Ogni disposizione dei presenti Termini è
        da considerarsi separabile, pertanto, se una disposizione è in conflitto
        con la legge applicabile o viene ritenuta inapplicabile, le parti
        intendono che il presente Accordo sia applicato come se tale
        disposizione non fosse presente e che qualsiasi disposizione
        parzialmente valida e applicabile sia applicata nella misura in cui
        risulti effettivamente applicabile.
      </p>
      <p>
        9.4. Intero Accordo: Qualora il PAM accetti un’Offerta, in tutto o in
        parte, e decida di selezionare un’Offerta vincente, i presenti Termini,
        insieme all’Offerta dell’Offerente e all’email di conferma da parte del
        PAM relativa alla selezione dell’Offerente, costituiranno il contratto
        vincolante ed esecutivo tra il PAM e l’Offerente vincente. Qualora
        esistano più versioni linguistiche dei presenti Termini e vi siano
        discrepanze tra di esse, prevarrà sempre la versione in lingua inglese.
      </p>
      <p>
        9.5. Contatti: Per qualsiasi domanda relativa ai presenti termini e
        condizioni, alla Piattaforma o a una specifica asta, si prega di
        contattare: support.auctiondigitaloffice@wfp.org
      </p>
      <p>Ultima modifica: 12 febbraio 2024</p>
    </Container>
  );
};
